import React, { useState } from "react";
import Input from "../../../../../../../../../../../../components/Input";

export default function CustomAppLinks({
                                           app, messages, update
                                       }) {

    const [urlApp, setUrlApp] = useState(app.url_app);
    const [urlGit, setUrlGit] = useState(app.url_git);

    const url_app_label = 'Application website';
    const url_git_label = 'Git repository url';

    return (
        <>
            <Input
                style={{paddingTop: 0}}
                id={`app-${app._id}-url-app`}
                name='url_app'
                placeholder={url_app_label}
                iconLeft='fas fa-globe'
                maxLength={50}
                isValid={messages.find(m => m.part === `app-${app._id}-url-app`) ? false : undefined}
                error={messages.find(m => m.part === `app-${app._id}-url-app`)?.message}
                value={urlApp}
                onChange={e => {
                    const {value} = e.target;
                    update({url_app: value,});
                    setUrlApp(value);
                }}
            />
            <Input
                id={`app-${app._id}-url-git`}
                name='url_git'
                placeholder={url_git_label}
                iconLeft='fab fa-github'
                maxLength={50}
                isValid={messages.find(m => m.part === `app-${app._id}-url-git`) ? false : undefined}
                error={messages.find(m => m.part === `app-${app._id}-url-git`)?.message}
                value={urlGit}
                onChange={e => {
                    const {value} = e.target;
                    update({url_git: value,});
                    setUrlGit(value);
                }}
            />
        </>
    )
}